(function () {
  'use strict';

  var dock = document.querySelector('[data-kjs-search-dock]');
  var sentinel = document.querySelector('[data-kjs-search-sentinel]');
  var originalParent;
  var fixed = false;
  var anchorY = 0;
  var frame = 0;
  var requestFrame = window.requestAnimationFrame || function (callback) {
    return window.setTimeout(callback, 16);
  };
  var STICK_OFFSET = 4;
  var RELEASE_OFFSET = 4;

  if (!dock || !sentinel) {
    return;
  }

  /* Claim sticky handling before the inherited Release 2 script initializes. */
  dock.setAttribute('data-kjs-sticky-bound', 'true');
  dock.setAttribute('data-kjs-v5-sticky-bound', 'true');
  originalParent = sentinel.parentNode;

  function scrollY() {
    return window.pageYOffset || document.documentElement.scrollTop || 0;
  }

  function measureAnchor() {
    anchorY = sentinel.getBoundingClientRect().top + scrollY();
  }

  function setStuck(stuck) {
    if (stuck === fixed) {
      return;
    }

    fixed = stuck;
    if (stuck) {
      sentinel.style.height = dock.offsetHeight + 'px';
      sentinel.classList.add('is-stuck');
      document.body.appendChild(dock);
      dock.classList.add('is-stuck');
    } else {
      originalParent.insertBefore(dock, sentinel.nextSibling);
      dock.classList.remove('is-stuck');
      sentinel.classList.remove('is-stuck');
      sentinel.removeAttribute('style');
    }
  }

  function sync() {
    var currentY = scrollY();
    frame = 0;

    if (!fixed && currentY >= anchorY + STICK_OFFSET) {
      setStuck(true);
    } else if (fixed && currentY <= anchorY - RELEASE_OFFSET) {
      setStuck(false);
    }
  }

  function schedule() {
    if (!frame) {
      frame = requestFrame(sync);
    }
  }

  function handleResize() {
    if (fixed) {
      sentinel.style.height = dock.offsetHeight + 'px';
    }
    measureAnchor();
    schedule();
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', handleResize);
  window.addEventListener('pageshow', function () {
    measureAnchor();
    schedule();
  });

  measureAnchor();
  schedule();
}());

(function () {
  'use strict';

  var observer;

  function enhanceLocationCounts() {
    var panel = document.getElementById('inventoryLocationInformation');
    var counts;
    var index;
    var value;

    if (!panel) {
      return;
    }

    panel.setAttribute('role', 'region');
    panel.setAttribute('aria-label', 'Store stock by location');
    counts = panel.querySelectorAll('.stockCount');

    for (index = 0; index < counts.length; index += 1) {
      value = counts[index].textContent.replace(/^\s+|\s+$/g, '');
      if (value) {
        counts[index].setAttribute('aria-label', value + (/(^|\s)in stock$/i.test(value) ? '' : ' in stock'));
      }
    }
  }

  function startLocationEnhancement() {
    var purchasePanel = document.querySelector('.desc_blk_bot');

    if (!purchasePanel) {
      return;
    }

    enhanceLocationCounts();
    if (window.MutationObserver) {
      observer = new MutationObserver(enhanceLocationCounts);
      observer.observe(purchasePanel, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startLocationEnhancement);
  } else {
    startLocationEnhancement();
  }
}());

(function () {
  'use strict';

  function route(path) {
    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    return root.replace(/\/?$/, '/') + path;
  }

  function findButton(node) {
    while (node && node !== document) {
      if (node.getAttribute && node.getAttribute('data-kjs-card-add') !== null) {
        return node;
      }
      node = node.parentNode;
    }
    return null;
  }

  function statusRegion() {
    var region = document.getElementById('KjsCardCartStatus');

    if (!region) {
      region = document.createElement('p');
      region.id = 'KjsCardCartStatus';
      region.className = 'kjs-visually-hidden';
      region.setAttribute('role', 'status');
      region.setAttribute('aria-live', 'polite');
      region.setAttribute('aria-atomic', 'true');
      document.body.appendChild(region);
    }

    return region;
  }

  function announce(message) {
    var region = statusRegion();
    region.textContent = '';
    window.setTimeout(function () {
      region.textContent = message;
    }, 10);
  }

    function kjsCustomerCartItemCount(cart) {
    if (!cart || !Array.isArray(cart.items)) {
      return 0;
    }

    return cart.items.reduce(function (count, item) {
      var vendor = item && (item.vendor || (item.product && item.product.vendor));
      return vendor === 'Ship Sketch' ? count : count + (parseInt(item.quantity, 10) || 0);
    }, 0);
  }

  function updateCartLabels(count) {
    var links = document.querySelectorAll('#header a.cart-popup, #header a[href="/cart"], #header .navbar-cart > a');
    var index;
    var label = 'Shopping cart, ' + count + (count === 1 ? ' item' : ' items');

    for (index = 0; index < links.length; index += 1) {
      if (links[index].closest('kjs-delivery-picker')) continue;
      links[index].setAttribute('aria-label', label);
    }
  }

  function emitMeasurement() {
    var detail = { path: window.location.pathname, source: 'product_card' };

    try {
      document.dispatchEvent(new CustomEvent('kjs:add_to_cart', { detail: detail }));
    } catch (error) {
      /* Measurement is an enhancement only. */
    }

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({
        event: 'kjs_add_to_cart',
        path: detail.path,
        source: detail.source
      });
    }
  }

  function restoreButton(button, productTitle, delay) {
    window.setTimeout(function () {
      button.textContent = button.getAttribute('data-kjs-original-label') || 'Add to cart';
      button.setAttribute('aria-label', 'Add ' + productTitle + ' to cart');
      button.removeAttribute('aria-busy');
      button.removeAttribute('disabled');
      button.removeAttribute('data-kjs-cart-busy');
    }, delay);
  }

  function added(button, productTitle, cart) {
    button.textContent = 'Added';
    button.setAttribute('aria-label', productTitle + ' added to cart');
    announce(productTitle + ' was added to your cart.');
    updateCartLabels(kjsCustomerCartItemCount(cart));
    emitMeasurement();

    if (window.Shopify && typeof Shopify.updateQuickCart === 'function') {
      Shopify.updateQuickCart(cart);
      window.jQuery('.count').text(kjsCustomerCartItemCount(cart)).toggleClass('hidden', kjsCustomerCartItemCount(cart) === 0);
    } else {
      window.jQuery('.count').text(kjsCustomerCartItemCount(cart)).toggleClass('hidden', kjsCustomerCartItemCount(cart) === 0);
    }

    restoreButton(button, productTitle, 1800);
  }

  function addedWithoutCartRefresh(button, productTitle) {
    var counts = document.querySelectorAll('.count');
    var currentCount = counts.length ? parseInt(counts[0].textContent, 10) || 0 : 0;
    var index;

    button.textContent = 'Added';
    button.setAttribute('aria-label', productTitle + ' added to cart');
    announce(productTitle + ' was added to your cart. Refresh the page if the cart count does not update.');
    emitMeasurement();

    for (index = 0; index < counts.length; index += 1) {
      counts[index].textContent = currentCount + 1;
      counts[index].classList.remove('hidden');
    }
    updateCartLabels(currentCount + 1);
    restoreButton(button, productTitle, 1800);
  }

  function failed(button, productTitle, xhr, textStatus) {
    var message = 'This item could not be added. Please try again.';

    try {
      message = JSON.parse(xhr.responseText).description || message;
    } catch (error) {
      /* Use the clear fallback message. */
    }

    button.textContent = 'Try again';
    announce(message);

    if (window.Shopify && typeof Shopify.onError === 'function') {
      Shopify.onError(xhr, textStatus);
    }

    restoreButton(button, productTitle, 2200);
  }

  document.addEventListener('click', function (event) {
    var button = findButton(event.target);
    var variantId;
    var productTitle;

    if (!button || button.getAttribute('data-kjs-cart-busy') === 'true') {
      return;
    }

    variantId = button.getAttribute('data-variant-id');
    productTitle = button.getAttribute('data-product-title') || 'Product';

    if (!variantId || !window.jQuery) {
      return;
    }

    event.preventDefault();
    button.setAttribute('data-kjs-original-label', button.textContent.replace(/^\s+|\s+$/g, ''));
    button.setAttribute('data-kjs-cart-busy', 'true');
    button.setAttribute('aria-busy', 'true');
    button.setAttribute('disabled', 'disabled');
    button.textContent = 'Adding…';

    window.jQuery.ajax({
      type: 'POST',
      url: route('cart/add.js'),
      data: { id: variantId, quantity: 1 },
      dataType: 'json'
    }).done(function () {
      window.jQuery.getJSON(route('cart.js')).done(function (cart) {
        added(button, productTitle, cart);
      }).fail(function () {
        /* The add already succeeded; do not report it as a failed cart action. */
        addedWithoutCartRefresh(button, productTitle);
      });
    }).fail(function (xhr, textStatus) {
      failed(button, productTitle, xhr, textStatus);
    });
  }, false);
}());
